import { render, staticRenderFns } from "./PagedListPlaylists.vue?vue&type=template&id=51d2f9af&"
import script from "./PagedListPlaylists.vue?vue&type=script&lang=js&"
export * from "./PagedListPlaylists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports